import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const getCampianGroups = async (user, page, page_size, search) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `/service/accounts_service/v1/accounts/wa/number/all/group`,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,
            },
            params: { page, page_size, search }
        };
        const response = await axios.request(config);
        return response.data;
    } catch (err) {
        console.log(err);

    }
};

export default getCampianGroups;
